import React from "react";
import {CircularProgress, Typography, useTheme} from "@material-ui/core";
import {CheckCircle, ErrorOutline} from "@material-ui/icons";
import useStyles from "./styles"
import Rest from "../../../helpers/Rest";

class Check extends React.Component{
    constructor(props) {
        super(props);
        /*this.state = {
            checking: true,
            usable: false,
            minHeight: 0
        }
        this.checkDevice()*/
        this.state = {
            checking: false,
            usable: true
        }
    }

    getState(){
        return Rest.get(`registration/${this.props.qrCode}/health`).then(reply => {
            return reply.usable
        })
    }

    componentWillUnmount() {
        if (this.timer){
            window.clearTimeout(this.timer)
        }
    }

    checkDevice(){
        //They insist it pretend to be slow so they can see
        //the loading animation so we stick in a little timeout
        window.setTimeout(() => this.getState().then(usable => {
            this.setState({
                checking: false,
                usable: usable
            })
        }), 1000)
    }

    loader(){
        const classes = this.props.classes
        return (
            <div className={classes.main}>
                <Typography variant="h4" color="primary">
                    Safety Check
                </Typography>
                <Typography color="textSecondary">
                    Please wait for test to complete
                </Typography>
                <div className={classes.centreAbsolute}>
                    <CircularProgress size={160} color="primary"/>
                    <div style={{fontSize:"1.5em", marginTop:64}}>Testing<br/>Device</div>
                </div>
            </div>
        )
    }

    loaded(){
        const classes = this.props.classes,
            colour = this.props.theme.palette.success.main
        return (
            <div className={classes.main}>
                <Typography variant="h4" style={{color:colour}}>
                    TEST PASSED
                </Typography>
                <Typography>
                    Leave this page open or scan the PDU
                    to sign out when you leave the site
                </Typography>
                <div className={classes.centreAbsolute}>
                    <CheckCircle style={{fill:colour}}/>
                </div>
            </div>
        )
    }

    notTesting(){
        const classes = this.props.classes,
            colour = this.props.theme.palette.success.main
        return (
            <div className={classes.main}>
                <Typography variant="h4" style={{color:colour}}>
                    SUCCESS
                </Typography>
                <Typography>
                    Leave this page open or scan the PDU
                    to sign out when you leave the site
                </Typography>
                <div className={classes.centreAbsolute}>
                    <CheckCircle style={{fill:colour}}/>
                </div>
            </div>
        )
    }

    error(){
        const classes = this.props.classes,
            colour = this.props.theme.palette.error.main
        return (
            <div className={classes.main}>
                <Typography variant="h4" style={{color:colour}}>
                    TEST FAILED
                </Typography>
                <Typography>
                    This device is faulty please use a different one
                </Typography>
                <div className={classes.centreAbsolute}>
                    <ErrorOutline style={{fill:colour}}/>
                </div>
            </div>
        )
    }

    render() {
        /*if (this.state.checking){
            return this.loader()
        }
        if (this.state.usable){
            return this.loaded()
        }
        return this.error()*/
        return this.notTesting();
    }
}

export default function(props){
    const theme = useTheme()
    const classes = useStyles(theme)
    return <Check classes={classes} theme={theme} {...props}/>
}
